import { get } from 'lodash';

export function getSharepointLocation(data) {
  return `fahrzeugangebot/${['dev', 'staging'].includes(process.env.REACT_APP_CURRENT_ENV) ? 'DEV_' : ''}${get(
    data,
    'uds_name'
  )}`;
}
